import { cp } from "../config";

/**
 * Whether the student may see the *judgmental* scoring layer — false in production until the E3
 * reveal (HALLOFUSS-6704). Everything is computed and carried regardless; only the display waits.
 *
 * What this gates, and what it does not:
 * - **Gated** — per-answer point values, the exercise cards' coloured bar and progress ring. The
 *   colour is the judgment ("you did badly here"), so it leaks the result as plainly as a number.
 * - **Not gated** — right/wrong per answer, the overall percentage, and the per-exercise points.
 *   Those are baseline feedback the old result already gave, or factual rather than a verdict.
 *
 * Read at call time, not module scope: `cp.cfg` is only populated once index.tsx has fetched the
 * config, which happens after this module is imported.
 *
 * An unset environment reveals rather than hides, so a misconfigured deploy is visibly wrong in
 * testing instead of silently behaving like production.
 */
export const getIsScoreRevealed = (): boolean => cp.cfg?.ENVIRONMENT !== "prod";

/**
 * Whether a result may show point values: a scored test *and* the reveal. On an unscored test every
 * maximum is 1, so a number would only restate the right/wrong marks beside it.
 */
export const getIsScoreShown = (isScored: boolean): boolean => isScored && getIsScoreRevealed();
